import { getCookies, userSessionCookieKey } from 'libs/common/cookies'

import * as trackingUserEventsApi from '../api/trackingUserEvents.api'
import { AppRootStore } from './appRoot.store'

const EVENT_REGISTRY = {
  app_prfmkt_funnel: [
    'account_view',
    'login_click',
    'checkout_started',
    'billing_type_change',
    'buy_now_click',
    'checkout_error',
    'summary_details_open',
    'plan_booked',
    'success_modal_view',
    'start_onboarding_click',
    'start_exploring_click',
    'countdown_expired',
    'funnel_resumed',
  ],
  app: ['page_view', 'seller_sign_up_success'],
} as const

export type PageType = keyof typeof EVENT_REGISTRY
export type EventType<T extends PageType> = (typeof EVENT_REGISTRY)[T][number]

interface EventDetails {
  sellerId: string
  userId: string
  userSessionId: string
  userAgent: string
  pageUrl: string
  pageReferer: string
}

export class TrackingUserEventsStore {
  storeName = 'TrackingUserEventsStore'
  private root: AppRootStore

  constructor(root: AppRootStore) {
    this.root = root
  }

  logEvent<T extends PageType>({
    pageType,
    eventType,
    value,
    payload = {},
  }: {
    pageType: T
    eventType: EventType<T>
    value?: string
    payload?: Record<string, any>
  }) {
    this.dispatchLogService(pageType, eventType, payload)
    this.dispatchExperimentService(pageType, eventType, value ?? pageType, payload)
  }

  private dispatchLogService<T extends PageType>(pageType: T, eventType: EventType<T>, payload: Record<string, any>) {
    trackingUserEventsApi.track({
      pageType,
      eventType: `${pageType}__${eventType}`,
      eventDetails: this.eventDetails,
      pageDetails: {},
      eventPayload: payload,
    })
  }

  private dispatchExperimentService<T extends PageType>(
    pageType: T,
    eventType: EventType<T>,
    value: string,
    payload: Record<string, any>
  ) {
    this.root.experimentsStore.logEvent(`${pageType}__${eventType}`, value, payload)
  }

  private get eventDetails(): EventDetails {
    return {
      sellerId: this.root.sellerStore.item?.id?.toString() || '',
      userId: this.root.sellerStore.item?.userId?.toString() || this.root.userStore.item?.id?.toString() || '',
      userSessionId: getCookies(userSessionCookieKey) || '',
      userAgent: window.navigator.userAgent,
      pageUrl: window.location.href,
      pageReferer: document.referrer,
    }
  }
}
